import { EVENT_TYPE } from '@/common/resources/const'

/**
 * find on-navigation from event list
 * @param eventList
 * @returns {*}
 */
export const getOnNavigation = (eventList = []) => {
  return eventList.find((event) => event.type === EVENT_TYPE.ON_NAVIGATION)
}
